import axios from 'axios';
import { AccommodationGroupQueryFilters } from '../../features/accommodations/accommodationGroupsSlice';
import apiRequestHeaders from '../apiRequestHeaders';

export function fetchAllAccommodationGroups(
  filterRequest: AccommodationGroupQueryFilters,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    contentType: 'application/json;charset=UTF-8',
  };

  return axios
    .post(
      '/accommodation/accommodationgroups/getAllAccommodationGroups',
      filterRequest,
      config,
    )
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAccommodationGroupDetails(accommodationGroupId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationGroupId },
  };

  return axios
    .get(
      '/accommodation/accommodationgroups/getAccommodationGroupDetails',
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateAccommodationGroup(accommodationGroupData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodationgroups/updateaccommodationgroup',
      accommodationGroupData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function addAccommodationGroup(accommodationGroupData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/accommodation/accommodationgroups/addaccommodationgroup',
      accommodationGroupData,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function deleteAccommodationGroup(accommodationGroupId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationGroupId },
  };
  return axios
    .delete(
      '/accommodation/accommodationgroups/deleteaccommodationgroup',
      config,
    )
    .then(res => {
      return res.data;
    });
}
